import { Box, HStack, Spacer, Text } from "@chakra-ui/react";
import { useMemo } from "react";
import {
  Bar,
  CartesianGrid,
  ComposedChart,
  Line,
  XAxis,
  YAxis,
} from "recharts";

const PDFMetricGraph = ({ metricGraphData }) => {
  // Prepare chart data similar to your Chart.js config
  const chartElement = useMemo(() => {
    const chartData =
      metricGraphData?.months?.map((month, index) => ({
        name: month,
        income: metricGraphData?.income[index] || 0,
        expenses: metricGraphData?.expense[index] || 0,
        profit: metricGraphData?.profit[index] || 0,
      })) || [];

    return (
      <ComposedChart
        data={chartData}
        margin={{ top: 20, right: 20, left: -10, bottom: 5 }}
        width={666}
        height={260}
      >
        <CartesianGrid stroke="#CCCCCC" vertical={false} />
        <XAxis
          dataKey="name"
          tick={{ fontSize: 12, fill: "#666" }}
          axisLine={{ stroke: "#CCCCCC" }}
          tickLine={false}
          tickMargin={5}
        />
        <YAxis
          tick={{ fontSize: 12, fill: "#666" }}
          axisLine={{ stroke: "#CCCCCC" }}
          tickLine={false}
          tickFormatter={(value) => {
            if (value === 0) return "0";
            if (Math.abs(value) >= 1000) return `${(value / 1000).toFixed(0)}K`;
            return `$${value}`;
          }}
          tickMargin={5}
        />
        <Bar
          dataKey="income"
          barSize={12}
          fill="#458CFF"
          radius={[10, 10, 0, 0]}
          isAnimationActive={false}
        />
        <Bar
          dataKey="expenses"
          barSize={12}
          fill="#FF5A5C"
          radius={[10, 10, 0, 0]}
          isAnimationActive={false}
        />
        <Line
          type="monotone"
          dataKey="profit"
          stroke="#00D26C"
          strokeWidth={4}
          dot={false}
          activeDot={false}
          isAnimationActive={false}
        />
      </ComposedChart>
    );
  }, [metricGraphData]);

  return (
    <Box
      width="100%"
      height="250px"
      bg="white"
      sx={{
        "& svg:focus, g:focus, path:focus": {
          outline: "none !important",
        },
      }}
    >
      <HStack wrap="wrap" pb={"5px"}>
        <Text fontSize={"18px"} fontWeight={500}>
          12-Month Income, Expenses and Profit
        </Text>
        <Spacer />
        <HStack>
          <Box
            backgroundColor={"#458CFF"}
            height={"15px"}
            width={"15px"}
            borderRadius={"5px"}
          ></Box>
          <Text fontSize={"14px"} mr={"4px"} textAlign={"left"}>
            Income
          </Text>
          <Box
            backgroundColor={"#FF5A5C"}
            height={"15px"}
            width={"15px"}
            borderRadius={"5px"}
          ></Box>

          <Text fontSize={"14px"} mr={"4px"} textAlign={"left"}>
            Expenses
          </Text>
          <Box
            backgroundColor={"#00D26C"}
            height={"4px"}
            width={"20px"}
            borderRadius={"5px"}
          ></Box>
          <Text fontSize={"14px"} mr={"4px"} textAlign={"left"}>
            Profit
          </Text>
        </HStack>
      </HStack>

      {chartElement}
    </Box>
  );
};

export default PDFMetricGraph;
